export default [
  {
    url: "/company-dashboard",
    name: "Dashboard",
    slug: "dashboard-company",
    icon: "pie_chart",
  },
  {
    name: "Funcionários",
    slug: "employees",
    icon: "business_center",
    i18n: "employees",
    submenu: [
      {
        url: "/employees-and-credit-recharge",
        name: "Listar",
        slug: "employees-and-credit-recharge",
        icon: "play_arrow",
      },
      {
        url: "/register-new-employee",
        name: "Cadastrar",
        slug: "register-new-employee",
        icon: "play_arrow",
      },
      {
        url: "/employees-with-pending-fees",
        name: "Taxas pendentes",
        slug: "employees-with-pending-fees",
        icon: "play_arrow",
      },
      {
        url: "/employee-payment-report",
        name: "Relatórios",
        slug: "employee-payment-report",
        icon: "play_arrow",
      },
    ],
  },
  {
    name: "Planilhas",
    slug: "spreadsheets",
    icon: "list_alt",
    i18n: "spreadsheets",
    submenu: [
      {
        url: "/employees-spreadsheet",
        name: "Funcionários",
        slug: "employees-spreadsheet",
        icon: "play_arrow",
      },
    ],
  },
  {
    name: "Contratação",
    slug: "service-contracting-model",
    icon: "description",
    i18n: "service-contracting-model",
    submenu: [
      {
        url: "/company-contracts",
        name: "Contratos",
        slug: "company-contracts",
        icon: "play_arrow",
      },
      {
        url: "/company-campaigns",
        name: "Campanhas",
        slug: "company-campaigns",
        icon: "play_arrow",
      },
    ],
  },
  {
    name: "Conta Pool",
    slug: "spreadsheets",
    icon: "attach_money",
    i18n: "pool-account",
    submenu: [
      {
        url: "/pool-account-profiles",
        name: "Perfil",
        slug: "pool-account-profiles",
        icon: "play_arrow",
      },
      {
        url: "/pool-account-administration",
        name: "Administração",
        slug: "pool-account-administration",
        icon: "play_arrow",
      },
      {
        url: "/pool-account-extract",
        name: "Extrato",
        slug: "pool-account-extract",
        icon: "play_arrow",
      },
    ],
  },
  {
    url: "/profile",
    name: "Dados cadastrais",
    slug: "profile",
    icon: "location_city",
  },
  {
    url: "/logout",
    name: "Sair",
    slug: "logout",
    icon: "power_settings_new",
  },

]
